(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommender"] && !Shopify.designMode) return;
  try {
    
    class ProductRecommender extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      
      init() {
        this.state = {
          portions: 6,
          selected: new Set(),
          availableIds: new Set(),
        };
  
        this.$ = {
          grid: this.querySelector('[data-pr-grid]'),
          cards: Array.from(this.querySelectorAll('[data-pr-card]')),
          range: this.querySelector('[data-pr-range]'),
          portionLabels: Array.from(this.querySelectorAll('[data-pr-portions]')),
          selectedCountEls: Array.from(this.querySelectorAll('[data-pr-selected-count]')),
          availableCountEl: this.querySelector('[data-pr-available-count]'),
          empty: this.querySelector('[data-pr-empty]'),
          btnAdd: this.querySelector('[data-pr-add]'),
          totalPrice: this.querySelector('[data-pr-total-price]'),
          totalAmount: this.querySelector('[data-pr-total-amount]'),
          footer: this.querySelector('.pr-footer'),
        };

        this.bindEvents();
        this.seedRandomRaciones();
        this.updateRangeFill();
        this.updateAvailability();
        this.observeGridVisibility();
      }
  
      bindEvents() {
        if (this.$.range) {
          this.$.range.addEventListener('input', () => {
            this.state.portions = parseInt(this.$.range.value, 10);
            this.syncPortionLabels();
            this.updateRangeFill();
            this.updateAvailability();
          });
        }
  
        this.$.cards.forEach((card) => {
          card.addEventListener('click', () => this.toggleCard(card));
          card.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleCard(card);
            }
          });
        });
  
        this.$.btnAdd?.addEventListener('click', () => {
           this.addSelectedVariantsToCart();
        });
      }
  
      syncPortionLabels() {
        this.$.portionLabels.forEach((el) => (el.textContent = String(this.state.portions)));
      }
  
      updateRangeFill() {
        // Optional visual track fill hook
      }
  
      seedRandomRaciones() {
         // No longer needed - using metafields for min/max portions
      }

      observeGridVisibility() {
        if (!this.$.footer) return;

        const isMobile = window.innerWidth <= 767;
        if (!isMobile) return;

        const isProductPage = window.location.pathname.includes('/products');
        const scrollThreshold = isProductPage ? 1100 : 500;

        const handleScroll = () => {
          const scrollY = window.scrollY || window.pageYOffset;
          if (scrollY > scrollThreshold) {
            this.$.footer.classList.add('active');
          } else {
            this.$.footer.classList.remove('active');
          }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();

        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            const isMobileNow = window.innerWidth <= 767;
            if (!isMobileNow) {
              this.$.footer.classList.remove('active');
            } else {
              handleScroll();
            }
          }, 250);
        });
      }
  
      updateAvailability() {
        const value = this.state.portions;
        let availableCount = 0;
        this.state.availableIds.clear();
        this.$.cards.forEach((card) => {
          const min = parseFloat(card.getAttribute('data-min-portions') || '0');
          const max = parseFloat(card.getAttribute('data-max-portions') || '0');
           // Show variants whose range includes the selected raciones
          const isAvailable = value >= min && value <= max && max > 0;
  
          if (isAvailable) {
            availableCount++;
             this.state.availableIds.add(card.getAttribute('data-variant-id'));
            // Show with fade-in if was hidden
            if (card.hidden) {
              card.hidden = false;
              card.classList.add('pr-card--appearing');
              requestAnimationFrame(() => {
                // Trigger transition
                card.classList.remove('pr-card--appearing');
              });
            }
          } else {
            // Deselect and fade out, then hide
            card.setAttribute('aria-pressed', 'false');
             this.state.selected.delete(card.getAttribute('data-variant-id'));
            if (!card.hidden) {
              card.classList.add('pr-card--hiding');
              setTimeout(() => {
                card.hidden = true;
                card.classList.remove('pr-card--hiding');
              }, 250);
            } else {
              card.hidden = true;
            }
          }
        });
  
        if (this.$.availableCountEl) this.$.availableCountEl.textContent = String(availableCount);
        this.refreshSelectionUI();
         this.updateTotalPrice();
      }
  
      toggleCard(card) {
         const id = card.getAttribute('data-variant-id');
        if (!this.state.availableIds.has(id)) return;
        if (this.state.selected.has(id)) {
          this.state.selected.delete(id);
          card.setAttribute('aria-pressed', 'false');
        } else {
          this.state.selected.add(id);
          card.setAttribute('aria-pressed', 'true');
        }
        this.refreshSelectionUI();
      }
  
      refreshSelectionUI() {
        this.$.cards.forEach((card) => {
           const id = card.getAttribute('data-variant-id');
          card.setAttribute('aria-pressed', this.state.selected.has(id) ? 'true' : 'false');
        });
        const count = this.state.selected.size;
        this.$.selectedCountEls.forEach((el) => (el.textContent = String(count)));
        if (this.$.btnAdd) this.$.btnAdd.disabled = count === 0;
        if (this.$.empty) this.$.empty.hidden = this.state.availableIds.size > 0;
         this.updateTotalPrice();
       }
  
      selectAllAvailable() {
        this.state.selected = new Set(this.state.availableIds);
        this.refreshSelectionUI();
      }
  
       updateTotalPrice() {
         if (!this.$.totalPrice || !this.$.totalAmount) return;
   
         let total = 0;
         this.$.cards.forEach((card) => {
           const id = card.getAttribute('data-variant-id');
           if (this.state.selected.has(id) && !card.hidden) {
             const priceText = card.querySelector('.pr-price')?.textContent || '0';
             const price = parseFloat(priceText.replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
             total += price;
           }
         });
   
         // Always show the total price, even when it's 0
         this.$.totalAmount.textContent = total.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
         this.$.totalPrice.hidden = false;
       }
  
       addSelectedVariantsToCart() {
         if (this.state.selected.size === 0) return;
         
         const selectedVariants = Array.from(this.state.selected).map(variantId => {
           return {
             id: variantId,
             quantity: 1
           };
         });
  
         // Show loading state
         if (this.$.btnAdd) {
           this.$.btnAdd.classList.add('working');
         }
  
         // Add all variants to cart in a single request
         fetch('/cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify({
             items: selectedVariants
           })
         }).then(response => {
           if (response.ok) {
             console.log('All variants added to cart successfully');
             
             // Update cart UI and show drawer (same as PDP functionality)
             this.updateCartUI();
             
             // Clear selection after adding to cart
             this.state.selected.clear();
             this.refreshSelectionUI();
           } else {
             console.error('Error adding variants to cart');
           }
         }).catch(error => {
           console.error('Error adding variants to cart:', error);
         }).finally(() => {
           // Hide loading state
           if (this.$.btnAdd) {
             this.$.btnAdd.classList.remove('working');
           }
         });
       }
  
       updateCartUI() {
         // Check if we should show cart drawer (same conditions as PDP)
         if (!document.body.classList.contains('template-cart') && window.KROWN?.settings?.cart_action === 'overlay') {
           
           // Refresh cart content first
           fetch('?section_id=helper-cart')
             .then(response => response.text())
             .then(text => {
               const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
               const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
               const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
  
               // Update cart items
               const cartItems = document.getElementById('AjaxCartForm');
               if (cartItems) {
                 cartItems.innerHTML = cartFormInnerHTML;
                 if (cartItems.ajaxifyCartItems) {
                   cartItems.ajaxifyCartItems();
                 }
               }
  
               // Update cart subtotal
               const cartSubtotal = document.getElementById('AjaxCartSubtotal');
               if (cartSubtotal) {
                 cartSubtotal.innerHTML = cartSubtotalInnerHTML;
               }
  
               // Update header cart count and total
               document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
                 const cartCountEl = document.querySelector('#AjaxCartForm [data-cart-count]');
                 if (cartCountEl) {
                   elm.textContent = cartCountEl.textContent;
                 }
               });
               
               document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
                 const cartTotalEl = document.querySelector('#AjaxCartForm [data-cart-total]');
                 if (cartTotalEl) {
                   elm.textContent = cartTotalEl.textContent;
                 }
               });
  
               // Show cart drawer
               const cartDrawer = document.getElementById('site-cart-sidebar');
               if (cartDrawer) {
                 // cartDrawer.show();
                 window.PlanetDataset.SmartCart.methods.openDrawer(true, true);
                 
                 // Generate recommendations if available
                 const cartRecommendations = document.getElementById('cart-recommendations');
                 if (cartRecommendations && cartRecommendations.generateRecommendations) {
                   cartRecommendations.generateRecommendations();
                 }
               }
              // Shop Planet's cart
              // await window.PlanetDataset.SmartCart.methods.openDrawer(true, true);
             })
             .catch(error => {
               console.error('Error updating cart UI:', error);
             });
         }
      }
    }
  
    if (!customElements.get('product-recommender')) {
      customElements.define('product-recommender', ProductRecommender);
    }
  
  } catch(e) { console.error(e); }
})();
})();
